export type BookingPart = { index: number; total: number };

// A booking with several services is stored as one appointment per service, all in one
// appointment group (one sale, one payment). The day calendar draws each service as its own
// block, which read as a double booking - so number them "1 of 2", "2 of 2" to show they
// belong together. Only bookings with more than one service get a part.
export const getBookingParts = (
  appointments: { id: number; startTime: string; appointmentGroup?: { id?: number } | null }[]
): Map<number, BookingPart> => {
  const byGroup = new Map<number, { id: number; startTime: string }[]>();
  appointments.forEach((appointment) => {
    const groupId = appointment.appointmentGroup?.id;
    if (groupId == null) return;
    byGroup.set(groupId, [...(byGroup.get(groupId) || []), appointment]);
  });

  const parts = new Map<number, BookingPart>();
  byGroup.forEach((group) => {
    if (group.length < 2) return;
    [...group]
      .sort((a, b) => new Date(a.startTime).getTime() - new Date(b.startTime).getTime() || a.id - b.id)
      .forEach((appointment, i) => parts.set(appointment.id, { index: i + 1, total: group.length }));
  });
  return parts;
};
